import { api } from './_init'

export const fetchRecommendedEventsForCustomer = async (customerId) => {
  try {
    const response = await api.get(`/affinity/event_recommendations?customer_id=${customerId}`)
    if (response.status !== 200) {
      return {
        success: false,
        data: null,
      }
    }
    return {
      success: true,
      data: response.data,
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      error: error.message,
    }
  }
}